appComum.controller("PlaceIndicationController", [
  "$http",
  "$scope",
  "$timeout",
  "$window",
  "$cookies",
  "emissorService",
  function($http, $scope, $timeout, $window, $cookies, emissorService) {
    $scope.LOADING = false;
    $scope.feedbacks = null;
    $scope.estabelecimento = {};
    $scope.municipios = [];
    $scope.indiqueECFromCanal = false;
    $scope.googleMapsApiKey = "AIzaSyArBkXXYklblFqwlIMhunEV9XqvWOPWFd0";
    $scope.settings = {};
    $scope.auxModel = {};
    $scope.settings.showDescriptionField = false;

    constants.INDIQUE_EC_MESSAGES = {
      INDIQUE_EC_SUCCESS_MESSAGE:
        "Olá!</br>Agradecemos o seu contato e em breve daremos retorno sobre sua indicação.</br></br>Atenciosamente,</br>Equipe Telemarketing</br>Rede de Estabelecimentos.",
      GEOLOCATION_UNAVAILABLE: "Geolocalização indisponível."
    };

    $scope.closeFeedback = function(index) {
      $scope.feedbacks.splice(index, 1);
    };

    $scope.geolocation = function() {
      $scope.LOADING = true;
      if ($window.navigator.geolocation) {
        $window.navigator.geolocation.getCurrentPosition(function(position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ location: pos }, function(results, status) {
            if (status === google.maps.GeocoderStatus.OK && results.length >= 1) {
              // função utilizada pois a lista de cidades não está disponível à priori, somente depois de receber os dados via ajax
              var setCidade = function(cidade) {
                if ($scope.municipios.length === 0) {
                  $timeout(function() {
                    setCidade(cidade);
                  }, 1000);
                } else {
                  $scope.estabelecimento.cidade = cidade;
                  $scope.LOADING = false;
                  $scope.$apply();
                }
              };

              var address = results[0]["address_components"];
              for (var i = 0; i < address.length; i++) {
                for (var j = 0; j < address[i].types.length; j++) {
                  switch (address[i].types[j]) {
                    case "route":
                      $scope.estabelecimento.endereco = address[i]["long_name"];
                      break;
                    case "sublocality":
                      $scope.estabelecimento.bairro = address[i]["long_name"];
                      break;
                    case "administrative_area_level_1":
                      $scope.estabelecimento.uf = address[i]["short_name"];
                      $scope.changeUf($scope.estabelecimento.uf);
                      break;
                    case "administrative_area_level_2":
                      setCidade(address[i]["long_name"].toUpperCase());
                      break;
                  }
                }
              }

              if ($scope.municipios.length > 0) {
                $scope.LOADING = false;
                $scope.$apply();
              }
            } else {
              $scope.locationError(); // api do google não encontrou coordenadas
            }
          });
        }, $scope.locationError); // usuario se negou a fornecer geolocation
      } else {
        $scope.locationError(); // browser nao tem geolocation
      }
    };

    $scope.locationError = function() {
      $scope.feedbacks = [
        {
          type: "warning",
          msg: constants.INDIQUE_EC_MESSAGES.GEOLOCATION_UNAVAILABLE
        }
      ];
      $scope.LOADING = false;
    };

    $scope.indication = function() {
      $scope.LOADING = true;
      $scope.estabelecimento.siglaEmissor = emissorService.sigla;
      $scope.estabelecimento.numero = $scope.estabelecimento.numero.replace(/\D/gi, '');

      $http({
        method: "POST",
        url: "/api-web/comum/indique-ec/enviar",
        data: $scope.estabelecimento,
        headers: { "Content-Type": "application/json" }
      })
        .success(function() {
          $scope.LOADING = false;
          $scope.feedbacks = [
            {
              type: "success",
              msg: constants.INDIQUE_EC_MESSAGES.INDIQUE_EC_SUCCESS_MESSAGE
            }
          ];
          resetForm();
        })
        .error(function(data) {
          $scope.LOADING = false;
          $scope.feedbacks = [
            {
              type: "error",
              msg: data.message
            }
          ];
        });
    };

    $scope.changeUf = function(ufSelecionado) {
      $http({
        method: "GET",
        url: "/api-web/comum/cadastro/listar-municipios/" + ufSelecionado,
        headers: { "Content-Type": "application/json" }
      })
        .success(function(data, status, headers, config) {
          $scope.municipios = data;
        })
        .error(function(data, status, headers, config) {
          $scope.municipios = [];
          console.error(data.message);
        });
      return false;
    };

    $scope.changeTipoEstabelecimento = function(newValue) {
      if (newValue.toLowerCase() === "outros") {
        $scope.estabelecimento.tipoEstabelecimento = "";
        $scope.settings.showDescriptionField = true;
      } else {
        $scope.settings.showDescriptionField = false;
        $scope.auxModel.descricaoTipoEstabelecimento = "";

        if ($scope.createplace.descricao_tipo_estabelecimento) {
          $scope.createplace.descricao_tipo_estabelecimento.$setPristine();
        }
        $scope.estabelecimento.tipoEstabelecimento = newValue;
      }
    };

    $scope.manageProductRequire = function() {
      var products = $scope.auxModel.produtos;
      $scope.hasProductChecked = false;
      $scope.estabelecimento.listaProdutos = [];
      angular.forEach(products, function(value, key) {
        if (value === true) {
          $scope.estabelecimento.listaProdutos.push(key);
          $scope.hasProductChecked = true;
        }
      });
    };

    $scope.changeDescricaoTipoEstabelecimento = function(newValue) {
      if ($scope.settings.showDescriptionField) {
        $scope.estabelecimento.tipoEstabelecimento = $scope.auxModel.descricaoTipoEstabelecimento;
      }
    };

    function resetForm() {
      $scope.createplace.$setUntouched();
      $scope.auxModel = {};
      $scope.estabelecimento = {};
      $scope.createplace.$setPristine();
    }

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("PlaceIndicationController", $scope);
    }

    $scope.isIndiqueECFromCanal = function() {
      return $scope.indiqueECFromCanal;
    };

    if ($cookies.jsonData && $cookies.jsonData !== "") {
      var dadosIndiqueEC = angular.fromJson($cookies.jsonData);
      $scope.estabelecimento.nomeEmpresa = replaceAllChars(decodeURIComponent(dadosIndiqueEC.nomeCanal), "+", " ");
      $scope.estabelecimento.tipoEmpresa = replaceAllChars(decodeURIComponent(dadosIndiqueEC.segmento), "+", " ");
      $scope.estabelecimento.contato = replaceAllChars(decodeURIComponent(dadosIndiqueEC.nome), "+", " ");
      $scope.estabelecimento.cpf = decodeURIComponent(dadosIndiqueEC.cpf);
      $scope.estabelecimento.email = decodeURIComponent(dadosIndiqueEC.email);
      $scope.indiqueECFromCanal = true;
      document.cookie = "jsonData=''" + ";path=/portal/;expires=" + new Date();
    }

    function replaceAllChars(theString, charToReplace, replacement) {
      if (theString.indexOf(charToReplace) < 0) {
        return theString;
      }
      theString = theString.replace(charToReplace, replacement);
      return replaceAllChars(theString, charToReplace, replacement);
    }

    function setupIndiqueEC() {
      $scope.LOADING = true;
      $http({
        method: "GET",
        url: "/api-web/comum/indique-ec/setup",
        headers: { "Content-Type": "application/json" }
      })
        .then(function(res) {
          $scope.settings.tipoEstabelecimentoList = res.data;
          $scope.LOADING = false;
        })
        .catch(function(res) {
          $scope.LOADING = false;
        });
    }

    setupIndiqueEC();

    function removerAcentos(str) {
      var acentos = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
      var sem_acento = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";
      retorno = "";

      for (i = 0; i < str.length; i++) {
        troca = false;

        for (a = 0; a < acentos.length; a++) {
          if (str.substr(i, 1) == acentos.substr(a, 1)) {
            retorno += sem_acento.substr(a, 1);
            troca = true;
            break;
          }
        }

        if (troca == false) {
          retorno += str.substr(i, 1);
        }
      }
      return retorno;
    }

    $scope.googlePlacesGetAutoComplete = function(searchText) {
      if (searchText.length >= 3) {
        $scope.LOADING = true;

        $http({
          method: "GET",
          url: "/api-web/ec/cadastro/google-places/auto-complete/" + searchText,
          headers: { "Content-Type": "application/json" }
        })
          .success(function(data, status, headers, config) {
            $scope.googlePlacesList = data;
            $scope.googlePlacesList.unshift({
              id: null,
              place_id: null,
              name: null,
              description: searchText,
              structured_formatting: {
                main_text: searchText,
                secondary_text: null
              }
            });
            $scope.LOADING = false;
          })
          .error(function(data, status, headers, config) {
            $scope.LOADING = false;
            $scope.googlePlacesList = [];
          });
      } else {
        $scope.googlePlacesList = [];
      }
    };

    $scope.googlePlacesGetDetails = function(place) {
      $scope.estabelecimento.nome = "";
      $scope.estabelecimento.endereco = "";
      $scope.estabelecimento.uf = "";
      $scope.estabelecimento.telefone = "";
      $scope.estabelecimento.numero = "";
      $scope.estabelecimento.cep = "";
      $scope.estabelecimento.cidade = "";
      $scope.estabelecimento.uf = "";

      if (!!place.id) {
        $scope.LOADING = true;

        $http({
          method: "GET",
          url: "/api-web/ec/cadastro/google-places/detail/" + place.place_id,
          headers: { "Content-Type": "application/json" }
        })
          .success(function(data, status, headers, config) {
            $scope.LOADING = false;
            var cep = "";
            var cidade = "";
            var telefone = "";

            if (typeof data.formatted_phone_number !== "undefined") {
              if (!!data.formatted_phone_number) {
                telefone = data.formatted_phone_number
                  .replace("(", "")
                  .replace(")", "")
                  .replace("-", "")
                  .replace(" ", "");
              }
            }

            if (typeof place.terms[3] !== "undefined") {
              cidade = removerAcentos(place.terms[3]["value"]);
            }

            if (data.formatted_address.indexOf(" - ") > 0) {
              var detailsAddress = data.formatted_address.split(" - ");

              if (detailsAddress.toString().indexOf(", ") > 0) {
                var detailsEstadoCep = detailsAddress[2].split(",");
                cep = detailsEstadoCep[1].replace("-", "");
              }

              if (detailsAddress[0].indexOf(", ") > 0) {
                var detailsNumero = detailsAddress[0].split(",");
                $scope.estabelecimento.numero = detailsNumero[1];
              }
            }

            $scope.estabelecimento.telefone = telefone;
            $scope.estabelecimento.cep = cep;
            // console.log(place.terms, $scope.estabelecimento.numero);
            if (typeof place.terms[0] !== "undefined") {
              $scope.estabelecimento.nome = place.terms[0]["value"];
            }

            if (typeof place.terms[1] !== "undefined" && typeof place.terms[2] !== "undefined") {
              $scope.estabelecimento.endereco = place.terms[1]["value"] + " - " + place.terms[2]["value"];
            }

            if (typeof place.terms[4] !== "undefined") {
              $scope.estabelecimento.uf = place.terms[4]["value"];
              $scope.changeUf(place.terms[4]["value"]);
            }

            $timeout(function() {
              $scope.estabelecimento.cidade = cidade.toUpperCase();
            }, 1000);
          })
          .error(function(data, status, headers, config) {
            $scope.LOADING = false;
          });
      } else {
        $scope.estabelecimento.nome = place.description;
      }
    };
  }
]);
